import React, { Component } from 'react';
import Headroom from 'react-headroom';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Grid, Row, css, styled, thd, withTheme, up } from '@smooth-ui/core-sc';
import HeaderLogo from 'theme/Logo-2026.png';

const CustomHeadroom = styled(Headroom)`
  .headroom {
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
  }
  .headroom--unfixed {
    position: relative;
    transform: translateY(0);
  }
  .headroom--scrolled {
    transition: transform 200ms ease-in-out;
  }
  .headroom--unpinned {
    position: fixed;
    transform: translateY(-100%);
  }
  .headroom--pinned {
    position: fixed;
    transform: translateY(0%);
  }
`;

const HeaderWrapper = styled.div`
  background-image: linear-gradient(45deg, #8e4465 0, #175296 100%);
  border-bottom: 5px solid black;
  padding-top: 10px;
  width: 100%;

  .sui-grid {
    height: 100%;
  }

  .sui-row {
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
  }

  ${up(
    'lg',
    css`
      height: 110px;
    `
  )};
`;

const LogoContainer = styled.div`
  align-items: left;
  display: flex;
  height: 100%;
  justify-content: left;
  align-items: center;
  img {
    height: auto;
    width: 206px;
    margin-left: 10px;

    ${up(
      'lg',
      css`
        height: 150px;
        height: auto;
        width: 190px;
      `
    )}
  }
`;

const HeaderRightContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  justify-content: flex-end;

  ${up(
    'lg',
    css`
      flex-direction: column;
    `
  )}
`;

class Header extends Component {
  render() {
    return (
      <header className="site-header">
        {/* Leave the above <header /> here, necessary to contain Headroom */}
        {/* Otherwise Headroom will wrap all sibling elements */}
        <CustomHeadroom disableInlineStyles downTolerance={10}>
          <HeaderWrapper className="header-wrapper">
            <Grid>
              <Row>
                <LogoContainer>
                  <Link to="/">
                    <img src={HeaderLogo} alt="Rexel Online Advantage" />
                  </Link>
                </LogoContainer>
                <HeaderRightContainer>
                  {this.props.children}
                </HeaderRightContainer>
              </Row>
            </Grid>
          </HeaderWrapper>
        </CustomHeadroom>
      </header>
    );
  }
}

Header.propTypes = {
  children: PropTypes.node,
  theme: PropTypes.object,
};

Header.defaultProps = {
  children: undefined,
  theme: undefined,
};

export default withTheme(Header);
